<template>
  <div class="ml-5 mr-5 pb-5">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      class="mt-4"
    />
    <u-loader v-if="isLoading" />
    <div v-else>
      <b-row>
        <b-col cols="2">
          <label class="pt-4"><b>Jahr</b> </label>
        </b-col>
        <b-col cols="4">
          <v-text-field
            v-model="additionalHolidayObject.year"
            max="2099"
            min="1900"
            placeholder="Jahr eingeben..."
            step="1"
            type="number"
          />
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="2">
          <label class="pt-4"><b>Anzahl Tage</b> </label>
        </b-col>
        <b-col cols="4">
          <v-text-field
            v-model="additionalHolidayObject.noDays"
            placeholder="Anzahl Tage eingeben..."
            step="1"
            type="number"
          />
        </b-col>
      </b-row>

      <b-row>
        <label class="mx-3 mt-4 defaultLabel">
          Zusätzliche Feiertage sind ortsspezifisch
        </label>
        <v-checkbox
          v-model="additionalHolidayIsLocalised"
          color="#e72b37"
          hide-details
        />
      </b-row>

      <b-row v-if="additionalHolidayIsLocalised">
        <b-col cols="12">
          <u-tree-view
            v-model="additionalHolidayObject.additionalHolidayLocations"
            :tree-view-items="localisedOptions"
            class="mt-2"
            item-children="children"
            item-key="path"
            :display-feiertags-region-import="true"
          />
        </b-col>
      </b-row>

      <hr class="custom_hr">
      <b-row class="mt-4">
        <b-col cols="auto">
          <v-btn
            :disabled="
              !additionalHolidayObject.noDays || !additionalHolidayObject.year
            "
            color="success"
            tile
            @click="createAdditionalholiday"
          >
            <i class="fas fa-plus pr-2" />
            Erfassen
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn
            color="#e72b37"
            style="color: white"
            tile
            @click="cancel"
          >
            <i class="fas fa-ban pr-2" />
            Abbrechen
          </v-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import { CreateAdditionalholidays } from "@/services/minimum.wage.services/holidays.minimum.wages";
import UTreeView from "@/components/common/UTreeView.vue";
import { AggregatePlzArray } from "@/helpers/PlzHelper.js";
import { CreatedCountryMiloTreeView } from "@/helpers/TreeViewHelper";

export default {
  components: {
    UTreeView,
  },
  mixins: [MinimumWageMixin],
  props: {
    localisedOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      errorObject: "",
      additionalHolidayIsLocalised: false,
      additionalHolidayObject: {
        id: 0,
        configurationId: 0,
        year: "",
        noDays: "",
        additionalHolidayLocations: [],
      },
    };
  },
  created() {
    this.clearInputs();
  },  
  methods: {
    createAdditionalholiday() {
      let additionHolidayCopy = JSON.parse(
        JSON.stringify(this.additionalHolidayObject),
      );
      additionHolidayCopy.configurationId = this.editionId;
      additionHolidayCopy.year = parseInt(this.additionalHolidayObject.year);
      additionHolidayCopy.noDays = parseInt(
        this.additionalHolidayObject.noDays,
      );
      if (this.additionalHolidayIsLocalised) {
        let plzDtos = [];
        if (additionHolidayCopy.additionalHolidayLocations) {
          additionHolidayCopy.additionalHolidayLocations.map((entry) => {
            let obj = {
              Id: 0,
              additionalHolidayId: 0,
              path: entry,
            };
            plzDtos.push(obj);
          });
        }

        additionHolidayCopy.additionalHolidayLocations = AggregatePlzArray(
          plzDtos,
          CreatedCountryMiloTreeView(
            this.$store.state.mindestLohnKonfiguration.Cities,
          ),
        );
      } else {
        additionHolidayCopy.additionalHolidayLocations = [];
      }

      CreateAdditionalholidays(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        additionHolidayCopy,
        (response) => {
          if (response) {
            this.$emit("saved");
            this.clearInputs();
            this.isLoading = false;
          }
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    clearInputs() {
      this.additionalHolidayObject = {
        id: 0,
        configurationId: 0,
        year: "",
        noDays: "",
      };
    },

    cancel() {
      this.clearInputs();
      this.$emit("canceled");
    },
  },
};
</script>
<style scoped></style>
